import { AfterViewInit, Component, EventEmitter, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { EditOutingIterationDetailModalComponent } from 'src/app/shared/modals/edit-outing-iteration-detail-modal/edit-outing-iteration-detail-modal.component';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { OutingIterationDetailsService } from '../outing-iteration-details.service';
import { OutingIterationDetails } from './outing-iteration-details';
import { OutingIterationDetailsQueryFilter } from './outing-iteration-details-query-filter';
import { OutingIterationService } from 'src/app/outing/outing-iteration.service';
import { OutingIteration } from '../models/outing-iteration';

@Component({
    selector: 'app-outing-iteration-details',
    templateUrl: './outing-iteration-details.component.html',
    styleUrls: ['./outing-iteration-details.component.scss'],
    standalone: false
})
export class OutingIterationDetailsComponent extends BaseComponent implements OnInit, AfterViewInit {
  public iterationDetails: OutingIterationDetails[] = [];
  public updateFilterEvent = new EventEmitter<any>();
  public filter: OutingIterationDetailsQueryFilter = new OutingIterationDetailsQueryFilter();
  public id: string;
  public iteration: OutingIteration;
  public isDetailsLoading: boolean = false;

  public form = new FormGroup({
    name: new FormControl('',{
      validators: Validators.required
    }),
    description: new FormControl(''),
    cost: new FormControl(''),
    notes: new FormControl(),
    outingIterationId: new FormControl('',{
      validators: Validators.required
    }),
    createdBy: new FormControl(),
  });

  constructor(public sessionService: SessionService,
    private route: ActivatedRoute,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers,
    public dialog: MatDialog,
    private outingIterationDetailsService: OutingIterationDetailsService,
    private outingIterationService: OutingIterationService) {
    super(sessionService, stringHelpers);
    this.filter.sortColumn = 'name';
    this.filter.pageSize = 10;
    this.displayedColumns = ['name', 'description', 'cost', 'notes', 'actions'];
   }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id')
    this.selectedIteration = this.getGlobalOutingIteration();
    this.form.get('outingIterationId').patchValue(this.id);
    this.getIterationDetails();
    this.getIteration();
  }

  ngAfterViewInit(): void {
    this.globalDataService.routeEvent.emit(this.constructor.name);
  }

  getIteration(){
    this.isLoading = true;
    this.outingIterationService.getById(this.id).subscribe(result => {
      this.iteration = result;
      this.isLoading = false;
    }), err => {
      this.isLoading = false;
    };
  }

  getIterationDetails(){
    this.isDetailsLoading = true;
    this.filter.outingIterationId = this.id;
    this.outingIterationDetailsService.getAllByIterationId(this.filter).subscribe(result => {
      this.iterationDetails = result.results;
      this.filter.totalCount = result.totalCount;
      this.updateFilterEvent.emit(result.results);
      this.isDetailsLoading = false;
    }, err => {
      this.isDetailsLoading = false;
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getIterationDetails();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }

  onSubmit({value, valid}){
    if(valid){
      this.isDetailsLoading = true;
      value.createdBy = this.sessionService.getUserId();
      this.outingIterationDetailsService.create(value).subscribe(results => {
        this.form.reset();
        this.isDetailsLoading = false;
        this.getIterationDetails();
      },(err: any) => {
        this.isDetailsLoading = false;
        this.setError(err, this.form)
      });
    }
  }

  edit(detail: OutingIterationDetails) {
    const dialogRef = this.dialog.open(EditOutingIterationDetailModalComponent);
    dialogRef.componentInstance.detail.id = detail.id;
    dialogRef.componentInstance.detail.name = detail.name;
    dialogRef.componentInstance.detail.description = detail.description;
    dialogRef.componentInstance.detail.cost = detail.cost;
    dialogRef.componentInstance.detail.notes = detail.notes;
    dialogRef.componentInstance.detail.outingIterationId = this.id;
    dialogRef.componentInstance.detail.lastEditedBy = this.sessionService.getUserId();
    dialogRef.componentInstance.submitText = 'Save';

    dialogRef.afterClosed().subscribe((response) => {
      if (response == 'Save') {
        this.getIterationDetails();
      }
    });
  }

  delete(detail: OutingIterationDetails){
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Detail';
    dialogRef.componentInstance.body = `Are you sure you want to remove <strong>"${detail.name}"</strong>`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    
    dialogRef.afterClosed().subscribe((response) => {
      this.isLoading = true;
      if (response === 'Yes') {
        let model = {id: detail.id, lastEditedBy: this.getUserIdFromSession()};
        this.outingIterationDetailsService.delete(detail.id, model).subscribe(() => {
          this.getIterationDetails();
          this.isLoading = false;
        }, err => {
          this.isLoading = false;
        });
      }
      this.isLoading = false;
    });
  }

  canEditOrDelete(): boolean{
    return new Date() <= new Date(this.selectedIteration.startDate);;
  }
}
